// Universal mobile design tokens for the TFS App Hub ecosystem (Phase 1).
// Centralised so every module stays visually consistent on mobile while keeping
// its own approved brand accent. These are presentation tokens only — no logic.

export const NAVY = '#0E2A47';
export const GREEN = '#8FC93A';

// Convert a #RRGGBB hex to an rgba() string with the given alpha.
export const withAlpha = (hex, a) => {
  const h = (hex || '#000000').replace('#', '');
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${a})`;
};

// Approved per-module accent colours — sourced from the single authoritative
// module-identity config (lib/moduleIdentity) so colours never drift apart.
import { MODULE_IDENTITY } from '@/lib/moduleIdentity';

export const MODULE_THEME = {
  admin: { accent: MODULE_IDENTITY.tfs_admin.color, label: 'Administration' },      // charcoal / silver
  operations: { accent: MODULE_IDENTITY.tfs_ops.color, label: 'Operations' },       // TFS green
  rout: { accent: MODULE_IDENTITY.rout_admin.color, label: 'ROUT' },                // gold
  totalpay: { accent: MODULE_IDENTITY.payroll.color, label: 'Total Pay' },          // orange
  tally: { accent: MODULE_IDENTITY.contract_budgets.color, label: 'Tally' },        // purple
  team: { accent: MODULE_IDENTITY.team.color, label: 'TEAM' },                      // blue
};

export const moduleAccent = (key) => (MODULE_THEME[key]?.accent) || NAVY;

// Shared spacing rhythm for compact mobile dashboards (documented for reuse).
export const MOBILE_SPACING = {
  sectionGap: 'space-y-3 sm:space-y-4',
  cardPad: 'p-3 sm:p-4',
  gridGap: 'gap-2.5 sm:gap-3',
};
